import React, {Component, PropTypes} from 'react';
import CSSModules from 'react-css-modules'
import ReactTooltip from 'react-tooltip'
import { Link as ScrollLink } from 'react-scroll'
import config from 'config'
import container from '../../helpers/container'
import format from '../../helpers/format'
import {
  ContainerDivs,
  HomeEduCenter,
  Link,
  LinkIcon,
  ScrollToTop,
  SignupForm
} from '../../components'
import Styles from './EduCenterIndividual.css'


@CSSModules(Styles, {allowMultiple:true})
class TooltipText extends Component {
  static propTypes = {
    tipId: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props)
    const tip = {
      'tickers': [
        'tickers',
        'An abbreviation used to identify a publicly traded stock or mutual fund'
      ],
      'target-date-fund': [
        'target date fund',
        'Mutual funds that are selected based on the year the account holder plans to retire (the "target date")'
      ],
      'default-option': [
        'default option',
        'An investment option in which a mutual fund or funds are automatically selected for an employee if they are signed up for the plan but have not yet selected an option'
      ],
      'mutual-funds': [
        'mutual funds',
        'A type of investment that enables employees to invest in stocks, bonds, and other securities, usually grouped by investment objective'
      ],
      'plan-administrator': [
        'plan administrator',
        'The person responsible for managing a retirement plan including the plan’s investment options'
      ],
      'fiduciary-duty': [
        'fiduciary duty',
        'A legal and ethical duty to act solely in the interest of retirement plan participants'
      ]
    }[props.tipId || null]

    this.state = {
      tip
    }
  }

  render() {
    const { tip } = this.state

    if (!tip) { return null }

    const [tipName, tipText] = tip

    //
    return (
      <span
        styleName='tooltip-text'
        data-multiline
        data-effect='solid'
        data-tip={
          format.tooltipHtml(tipText)
        }
        data-html
        data-place='top'
        data-for={'tooltip-'+this.props.tipId}
      >
        {tipName}
      </span>
    )
  }
}


@CSSModules(Styles, {allowMultiple:true})
export default class EduCenter extends Component {
  constructor(props) {
    super(props)

    const emailTo = ''
    const emailSubject = 'Retirement plan sustainability'

    const planAdminEmailText = `
Dear Plan Administrator,

I am an employee of [Company Name], and I participate in our company retirement plan. I am writing to ask about environmentally and socially sustainable investment options in the plan.

I am concerned about the financial risks associated with investing my retirement savings in unsustainable industries. For example, laws curbing the use of fossil fuels are being put in place, energy efficiency measures are being implemented across nearly every sector of the economy, and renewable energy is driving down demand for fossil fuel-based energy. These changes pose substantial financial risk to fossil fuel companies. One example of this growing risk: over the past five years, the largest U.S coal companies have gone bankrupt, while other U.S. based coal firms have lost nearly 90% of their stock value.

I believe it is my right to know what companies my retirement savings are invested in. Can you please tell me how I can find out what companies are held in each of the investment options offered in our company plan? Does our retirement plan offer any fossil free, sustainable investment options? Is the default option of the retirement plan a sustainable investment?

Sustainable investing is no longer just an ethical issue. It is a key factor impacting financial well-being. New guidelines from the Department of Labor state that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be used when making decisions related to fiduciary duty.

Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you.

Best,

[Your Name]
    `

    const sustainabilityTeamEmailText = `
Dear Sustainability Team,

I am an employee of [Company Name], and I participate in our company retirement plan. I am writing to ask about environmentally and socially sustainable investment options in the plan.

I am concerned about the financial risks associated with investing my retirement savings in unsustainable industries. For example, laws curbing the use of fossil fuels are being put in place, energy efficiency measures are being implemented across nearly every sector of the economy, and renewable energy is driving down demand for fossil fuel-based energy. These changes pose substantial financial risk to fossil fuel companies. One example of this growing risk: over the past five years, the largest U.S coal companies have gone bankrupt, while other U.S. based coal firms have lost nearly 90% of their stock value.

I believe it is my right to know what companies my retirement savings are invested in. Can you please tell me how I can find out what companies are held in each of the investment options offered in our company plan? Does our retirement plan offer any fossil free, sustainable investment options? Is the default option of the retirement plan a sustainable investment?

Sustainable investing is no longer just an ethical issue. It is a key factor impacting financial well-being. New guidelines from the Department of Labor state that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be used when making decisions related to fiduciary duty.

Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you.

Best,

[Your Name]
    `

    const colleagueEmailText = `
Dear [colleague],

I just found out my 401(k) investments are funding fossil fuels and companies that are burning down the Amazon rainforest.

Unfortunately, the same may be true for you. You can learn more at this free tool with data on what's inside the mutual funds offered by 401(k) plans.

https://investyourvalues.org/

For most companies, the default option is invested in fossil fuels, deforestation, arms manufacturers, and companies that score poorly on gender equality.

I care about these issues and do not want my retirement savings to support companies that are destroying the environment and fueling social inequality.

We need to have more sustainable and climate-friendly investment options in our retirement plan, if we want to support an economy that is based on justice and sustainably through our retirement investments.

Thank you for taking the time to listen, and look forward to hearing from you soon.

Best,

[Your Name]
    `

    const planAdminEmailHref = `mailto:${emailTo}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(planAdminEmailText)}`

    const sustainabilityTeamEmailHref = `mailto:${emailTo}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(sustainabilityTeamEmailText)}`

    const colleagueEmailHref = `mailto:${emailTo}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(colleagueEmailText)}`

    this.state = {
      title: 'Five steps to a sustainable retirement plan',
      description: 'Resources for people to take action to make their employer-offered retirement plan more sustainable.',
      url: config.domain + config.routes.eduCenterIndividual,
      planAdminEmailHref,
      sustainabilityTeamEmailHref,
      colleagueEmailHref
    }
  }

  render() {
    const finRisk1 = require('../../../static/images/fin-risk-oil-chart.jpg')
    const finRisk2 = require('../../../static/images/fin-risk-deforestation.jpg')
    const navIcons = {
      1: require('../../../static/images/action-center-employees/icon1.jpg'),
      2: require('../../../static/images/action-center-employees/icon2.jpg'),
      3: require('../../../static/images/action-center-employees/icon3.jpg'),
      4: require('../../../static/images/action-center-employees/icon4.jpg'),
      5: require('../../../static/images/action-center-employees/icon5.jpg'),
    }

    const { planAdminEmailHref, sustainabilityTeamEmailHref,
            colleagueEmailHref } = this.state

    //
    return (
      <div id='top'>
        <div styleName='page'>
          {
            container.helmet(
              this.state.title,
              this.state.description,
              this.state.url
            )
          }
          <ContainerDivs>
            <h1 styleName='small-page-title'>
              {this.state.title}
            </h1>

            <section>
              <div styleName='answer-info'>
                <p>
                  Are your retirement savings funding the climate crisis? If
                  you don’t know, you’re not alone. Over 100 million employees
                  across the U.S. have over $10 trillion invested in
                  retirement savings, but very few know which companies they
                  are funding with their retirement dollars. Using this
                  toolkit, you will learn how to lower your financial risks
                  from unsustainable investments and maybe even help your
                  co-workers do the same.
                </p>
              </div>
            </section>

            <nav styleName='icon-nav'>
              {
                [
                  [0, 'learn-about-the-financial-risks-of-unsustainable-investments', 'Learn about the financial risks of unsustainable investments'],
                  [0, 'know-what-you-own', 'Know what you own'],
                  [0, 'take-action', 'Take action'],
                  [0, 'become-a-change-agent', 'Become a change agent'],
                  [0, 'join-the-movement', 'Join the movement'],
                ].map((e, i)=>{
                  return (
                    <button
                      key={e[1]}
                      styleName='scroll-to-item'
                    >
                      <ScrollLink
                        to={e[1]}
                        spy
                        smooth
                        offset={0}
                        duration={500}
                        title={e[2]}
                      >
                        <img
                          src={navIcons[i + 1]}
                          alt={e[2]}
                        />
                        <div styleName={'level-'+e[0]}>{e[2]}</div>
                      </ScrollLink>
                    </button>
                  )
                })
              }
            </nav>
            <hr/>


            <div styleName='answer'>
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              <section>
                <div styleName='anchor' id='learn-about-the-financial-risks-of-unsustainable-investments' />

                <h2 styleName='answer-subtitle-flex'>
                  <div styleName='answer-subtitle-bbl'>
                    1
                  </div>
                  <div>
                    Learn about the financial risks of unsustainable investments
                  </div>
                </h2>

                <div styleName='answer-info'>

                  <div styleName='text-img-cols'>
                    <div styleName='text-img-cols-text'>
                      <h3>
                        Unsustainable investments could put your 401(k) at risk
                      </h3>
                      <p>
                        There is a widespread myth that investing sustainably
                        means sacrificing returns. But if anything, the evidence
                        suggests the opposite is true. <Link
                          to={config.routes.eduCenterFinRisks}
                          title='Financial risks of unsustainable investments'
                          xstrong
                        >Learn more<LinkIcon /></Link>
                      </p>
                    </div>
                    <div styleName='text-img-cols-img'>
                      <Link
                        to={config.routes.eduCenterFinRisks}
                        title='Financial risks of unsustainable investments'
                      >
                        <img
                          src={finRisk1}
                          alt='Financial risks of unsustainable investments'
                        />
                      </Link>
                    </div>
                  </div>

                  <div styleName='text-img-cols'>
                    <div styleName='text-img-cols-text'>
                      <h3>
                        Your retirement plan is fueling the climate crisis and social inequality
                      </h3>
                      <p>
                        Companies hidden in your retirement plan may be fueling
                        deforestation, the use of fossil fuels, and even
                        contributing to societal challenges like gender
                        inequality and mass incarceration. <Link
                          to={config.routes.issues}
                          title='The issues'
                          xstrong
                        >Learn more<LinkIcon /></Link>
                      </p>
                    </div>
                    <div styleName='text-img-cols-img'>
                      <Link
                        to={config.routes.issues}
                        title='The issue'
                      >
                        <img
                          src={finRisk2}
                          alt='The issue'
                        />
                      </Link>
                    </div>
                  </div>

                  <ScrollToTop />
                  <hr/>
                </div>
              </section>
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              <section>
                <div styleName='anchor' id='know-what-you-own' />

                <h2 styleName='answer-subtitle-flex'>
                  <div styleName='answer-subtitle-bbl'>
                    2
                  </div>
                  <div>
                    Know what you own
                  </div>
                </h2>

                <div styleName='answer-info'>

                  <p>
                    Now that you understand the risk associated with unsustainable retirement investments, it’s time to find out if your investments are exposed to these risks.
                  </p>

                  <h3>
                    See if we’ve scored your company
                  </h3>
                  <p>
                    If you work at a big company, we might have already graded
                    your retirement plan. To find out, visit our <Link
                      to={config.routes.plans}
                      title='The data: Retirement plans'
                      xstrong
                    >retirement plans page</Link>. If
                    you don’t see your company, don’t fret: you can look up
                    your funds by following the steps below.
                  </p>

                  <div styleName='one-col'>
                    <Link
                      to={config.routes.plans}
                      title='The data: Retirement plans'
                      transparentbutton
                    >
                      Retirement plans<LinkIcon/>
                    </Link>
                  </div>

                  <h3>
                    Find your plan lineup
                  </h3>
                  <p>
                    To start, log into your retirement portal to look up what funds are available to you, and write down the names or <TooltipText tipId='tickers' />. More likely than not, your company has selected a <TooltipText tipId='target-date-fund' /> as the <TooltipText tipId='default-option' />. If you are not invested in a target date, then you are likely invested in <TooltipText tipId='mutual-funds' />.
                  </p>

                  <ReactTooltip id='tooltip-tickers'/>
                  <ReactTooltip id='tooltip-target-date-fund'/>
                  <ReactTooltip id='tooltip-default-option'/>
                  <ReactTooltip id='tooltip-mutual-funds'/>

                  <h3>
                    Find your fund grades
                  </h3>
                  <p>
                    Use our database to look up our environmental and social
                    ratings for your funds.
                  </p>

                  <div styleName='two-cols-row'>
                    <div styleName='two-cols-col'>
                      <Link
                        to={config.routes.targetDateFunds}
                        title='Target date funds'
                        transparentbutton
                      >
                        Target date funds<LinkIcon/>
                      </Link>
                    </div>
                    <div styleName='two-cols-col'>
                      <Link
                        to={config.links.fff + '/funds'}
                        title='Mutual funds and ETFs'
                        transparentbutton
                      >
                        Mutual funds and ETFs<LinkIcon/>
                      </Link>
                    </div>
                  </div>

                  <br/>
                  <br/>

                  <ScrollToTop />
                  <hr/>
                </div>
              </section>
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              <section>
                <div styleName='anchor' id='take-action' />

                <h2 styleName='answer-subtitle-flex'>
                  <div styleName='answer-subtitle-bbl'>
                    3
                  </div>
                  <div>
                    Take action
                  </div>
                </h2>

                <div styleName='answer-info'>

                  <h3>
                    Identify the best person to speak with
                  </h3>
                  <p>
                    Your <TooltipText tipId='plan-administrator' /> is the person responsible for adding options to your retirement plan. You may already have sustainable options available, so you should contact your plan administrator to find out (you may have to email HR to help you find your plan administrator).
                  </p>

                  <ReactTooltip id='tooltip-plan-administrator'/>

                  <h3>
                    Contact your plan administrator
                  </h3>
                  <p>
                    Once you have the name and email of your plan administrator, it is time to contact them. Here’s an email we have written for you to get started.
                  </p>

                  <div styleName='one-col'>
                    <Link
                      to={planAdminEmailHref}
                      title='Email your plan admin'
                      targetBlank
                    >
                      <div styleName='take-action-icons'>
                        <p>
                          Email your plan admin
                        </p>
                        <div>
                          <LinkIcon nospace faclass='fa-envelope'/>
                        </div>
                      </div>
                    </Link>
                  </div>

                  <h3>
                    Make a switch
                  </h3>
                  <p>
                    If you find out you do have access to sustainable funds that meet your investment needs, then you can make a switch. If you don’t have sustainable options available, and management is not willing to add new options, it’s time to move on to the next step.
                  </p>

                  <ScrollToTop />
                  <hr/>
                </div>
              </section>
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              <section>
                <div styleName='anchor' id='become-a-change-agent' />

                <h2 styleName='answer-subtitle-flex'>
                  <div styleName='answer-subtitle-bbl'>
                    4
                  </div>
                  <div>
                    Become a change agent
                  </div>
                </h2>

                <div styleName='answer-info'>

                  <p>
                    If management is not willing to add sustainable options to your retirement plan, it is time to take your financial future into your own hands.
                  </p>

                  <h3>
                    Reach out to the sustainability team
                  </h3>
                  <p>
                    If you company has a sustainability team or department it is usually a good sign that your company cares about these issues, and they should be able to advocate on your behalf. You can use the same sample letter from above to reach out this team and start the conversation.
                  </p>

                  <div styleName='one-col'>
                    <Link
                      to={sustainabilityTeamEmailHref}
                      title="Email your company's sustainability team"
                      targetBlank
                    >
                      <div styleName='take-action-icons'>
                        <p>
                          Email your company's sustainability team
                        </p>
                        <div>
                          <LinkIcon nospace faclass='fa-envelope'/>
                        </div>
                      </div>
                    </Link>
                  </div>

                  <h3>
                    Email your co-workers and form a coalition
                  </h3>
                  <p>
                    If you’re writing to someone in power, advocating on behalf of 20 or even 10 people carries a lot more weight than just one. One way to spur interest would be to share the results from our tools with your fellow employees. All plan participants are offered the same basket of mutual funds as you are, so they are probably asking the same questions are you are right now.
                  </p>

                  <div styleName='one-col'>
                    <Link
                      to={colleagueEmailHref}
                      title='Email your colleagues'
                      targetBlank
                    >
                      <div styleName='take-action-icons'>
                        <p>
                          Email your colleagues
                        </p>
                        <div>
                          <LinkIcon nospace faclass='fa-envelope'/>
                        </div>
                      </div>
                    </Link>
                  </div>

                  <h3>
                    Keep pushing
                  </h3>
                  <p>
                    Management may not be responsive the first time you ask about sustainable investments. Be persistent – continue giving updates to your colleagues that you’ve organized, and keep raising the issue. The most important thing to highlight is that <Link
                      to={config.routes.eduCenterFinRisks}
                      title='Financial risks of unsustainable investments'
                      xstrong
                    >unsustainable investing carries real financial risks.</Link> Without sustainable investment options, employees are forced to assume those financial risks, which may be a violation of your retirement plan administrator’s <TooltipText tipId='fiduciary-duty' />.
                  </p>

                  <ReactTooltip id='tooltip-fiduciary-duty'/>

                  <ScrollToTop />
                  <hr/>
                </div>
              </section>
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              <section>
                <div styleName='anchor' id='join-the-movement' />

                <h2 styleName='answer-subtitle-flex'>
                  <div styleName='answer-subtitle-bbl'>
                    5
                  </div>
                  <div>
                    Join the movement
                  </div>
                </h2>

                <div styleName='answer-info'>
                  <p>
                    Now it is time to join the movement by advocating your power to invest in an economy that is based on justice and sustainability.
                  </p>

                  <h3>
                    Sign up for updates
                  </h3>
                  <p>
                    We'll let you know when new companies are added to our database.
                  </p>

                  <SignupForm />

                  <h3>
                    Support <i>As You Sow</i>
                  </h3>
                  <p>
                    <i>As You Sow</i>, the nonprofit behind Invest Your Values, has leveraged the power of shareholders to change the world’s biggest corporations for good since 1992. Every day, your gift helps tackle today’s toughest issues, like climate change, racial justice, ocean plastics, toxins in the food system, egregious CEO pay, and slavery in corporate supply chains. Consider joining our family of donors.
                  </p>

                  <div styleName='one-col'>
                    <Link
                      to={config.links.donate}
                      title='Donate to As You Sow'
                      transparentdonatebutton
                    >
                      Donate to <i>As You Sow</i><LinkIcon/>
                    </Link>
                  </div>

                  <br/>
                  <br/>

                  <ScrollToTop />
                  <hr/>
                </div>
              </section>
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            </div>

          </ContainerDivs>
        </div>
        <HomeEduCenter />
      </div>

    )
  }
}
